function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Folder_logo",
  "data-name": "Folder logo",
  transform: "translate(-265.608 -1024.615)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Folder_icon",
  "data-name": "Folder icon",
  transform: "translate(265.608 1024.615)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_30",
  "data-name": "Rectangle 30",
  d: "M0,0H29.927a2,2,0,0,1,2,2v9.052a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
  transform: "translate(12.28 6.198)",
  fill: "#ef9d3a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1042",
  "data-name": "Path 1042",
  d: "M39.216,47.581H10.081A2.055,2.055,0,0,1,8,45.552V9.029A2.055,2.055,0,0,1,10.081,7H35.054v4.058a2.055,2.055,0,0,0,2.081,2.029H41.3V45.552A2.055,2.055,0,0,1,39.216,47.581Z",
  transform: "translate(-1.757 -7)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1043",
  "data-name": "Path 1043",
  d: "M40.243,13.243H36.081A2.081,2.081,0,0,1,34,11.162V7Z",
  transform: "translate(-0.703 -7)",
  fill: "#d1d1d1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1044",
  "data-name": "Path 1044",
  d: "M45.7,47.379H4.081A2.081,2.081,0,0,1,2,45.3V14.081A2.081,2.081,0,0,1,4.081,12h8.671A2.078,2.078,0,0,1,14,12.416l7.215,5.411a2.078,2.078,0,0,0,1.249.416H45.7a2.081,2.081,0,0,1,2.081,2.081V45.3A2.081,2.081,0,0,1,45.7,47.379Z",
  transform: "translate(-2 -6.797)",
  fill: "#ffbc5a"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54",
  transform: "translate(41.622 11.446)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1045",
  "data-name": "Path 1045",
  d: "M44.081,18H42a2.081,2.081,0,0,1,2.081,2.081V45.054A2.081,2.081,0,0,1,42,47.135h2.081a2.081,2.081,0,0,0,2.081-2.081V20.081A2.081,2.081,0,0,0,44.081,18Z",
  transform: "translate(-42 -18)",
  fill: "#ef9d3a"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  transform: "translate(5.203 27.054)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1046",
  "data-name": "Path 1046",
  d: "M14.284,35.081H8.041a1.041,1.041,0,1,1,0-2.081h6.243a1.041,1.041,0,1,1,0,2.081Z",
  transform: "translate(-7 -33)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56",
  transform: "translate(5.203 32.257)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1047",
  "data-name": "Path 1047",
  d: "M23.649,40.081H8.041a1.041,1.041,0,0,1,0-2.081H23.649a1.041,1.041,0,0,1,0,2.081Z",
  transform: "translate(-7 -38)",
  fill: "#fff"
}))));

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.784,
    height: 40.581,
    viewBox: "0 0 45.784 40.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.704d894f.svg";
export { ForwardRef as ReactComponent };